import React, { useState } from "react";
import * as yup from "yup";
import TaxStatementForm from "./tax-statement-form";
import ApiProvider from "../../../apiProvider";
import { useMsal } from "@azure/msal-react";
import { formatShortDate } from "../../../Components/formatters";
import { CdsFormModal } from "clayco-component-library/lib";

const AddTaxStatement = ({
    selectedEmployee,
    show,
    setShow,
    setDocumentSubmitted,
}) => {
    const [attachment, setAttachment] = useState();
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const [type, setType] = useState("W2");
    const onClose = () => {
        setShow(false);
    };

    const w2Schema = yup.object().shape({
        type: yup.string().required(),
        stateWorked: yup.string().required("State is required"),
        company: yup.string().required("Company is required"),
        reportingYear: yup.string().required("Year is required"),
        attachment: yup.mixed().required("PDF is required"),
    });

    const h1095Schema = yup.object().shape({
        type: yup.string().required(),
        reportingYear: yup.string().required("Year is required"),
        attachment: yup.mixed().required("PDF is required"),
    })

    const onSubmit = async (formData) => {
        //console.log("this is firing");
        //console.log("form", formData);
        const frmData = new FormData();
        const frm = type === "W2" ? w2Schema.cast(formData) : h1095Schema.cast(formData);
        //console.log(attachment?.target?.files.item(0));
        frmData.append("file", attachment.file);
        frmData.append("stateWorked", frm.stateWorked);
        frmData.append("company", frm.company);
        frmData.append("reportingYear", frm.reportingYear);
        if (selectedEmployee?.id)
            frmData.append("employeeId", selectedEmployee.id);

        await apiProvider.Post(
            `taxstatement/AddTaxStatement/${type}`,
            frmData,
            "multipart/form-data"
        );
        setDocumentSubmitted(true);
        setShow(false);
    };

    const onError = (errors, e) => {
        console.log(errors, e);
    };
    return (
        <>
            <CdsFormModal
                title="Add Tax Statement"
                style={{ width: "100%" }}
                buttonActionText="Submitting"
                schema={ type === "W2"? w2Schema : h1095Schema}
                onError={onError}
                onSubmit={onSubmit}
                show={show}
                handleCloseClick={onClose}
                disablePrimaryButton={disableSubmitButton}
            >
                <TaxStatementForm setAttachment={setAttachment} show={show} type={type} setType={setType} />
            </CdsFormModal>
        </>
    );
};

export default AddTaxStatement;
